import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Plane, Clock } from "lucide-react";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { overline } from "@/components/kit";
import { DESTINATIONS, DESTINATION_ORDER } from "@/data/destinations";

export default function Voyages() {
  return (
    <>
      <Seo
        title="Voyages incentives & Team Building à l'étranger"
        description="Organisation de voyages d'entreprise, incentives et team building à l'étranger : Maroc, Espagne, Canada, Égypte, Antilles, Croatie, Belgique, Suisse. Devis 24h."
        keywords="voyage entreprise, incentive à l'étranger, team building étranger, séminaire à l'étranger, voyage incentive Maroc Espagne Canada Égypte Antilles Croatie Belgique Suisse, agence voyage d'affaires, organisation voyage groupe"
        path="/voyages"
      />

      <section className="border-b border-ink/10 bg-mist pt-36 pb-16 md:pt-44 md:pb-24" data-testid="voyages-hero">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
          <Reveal><span className={overline}>Voyages incentives</span></Reveal>
          <Reveal delay={1}>
            <h1 className="mt-6 max-w-5xl font-serif text-6xl font-medium leading-[0.92] tracking-tight text-ink md:text-8xl lg:text-9xl">
              Team building<br />& incentives à<br /><span className="italic text-lime-dim">l'étranger.</span>
            </h1>
          </Reveal>
          <Reveal delay={2}>
            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-ink/60">
              8 destinations phares, des programmes signature, un chef de projet dédié en France et un coordinateur sur place 24/7. Choisissez le pays qui vous inspire.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1440px] px-5 py-20 md:px-10 md:py-28">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {DESTINATION_ORDER.map((slug, i) => {
            const d = DESTINATIONS[slug];
            return (
              <motion.div
                key={slug}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08, duration: 0.7 }}
              >
                <Link
                  to={`/voyages/${slug}`}
                  className="group relative block h-full overflow-hidden rounded-2xl bg-ink text-white transition-transform duration-500 hover:-translate-y-1"
                  data-testid={`voyage-card-${slug}`}
                >
                  <div className="relative aspect-[4/5] overflow-hidden">
                    <img src={d.hero} alt={d.name} className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-110" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
                    <ArrowUpRight size={22} className="absolute right-5 top-5 text-white/70 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-lime" />
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <div className="flex items-center gap-3">
                        <span className="text-3xl">{d.flag}</span>
                        <span className="text-[11px] uppercase tracking-[0.2em] text-lime">{d.duration}</span>
                      </div>
                      <h3 className="mt-3 font-serif text-4xl font-medium leading-none text-white md:text-5xl">{d.name}</h3>
                      <p className="mt-3 font-serif text-lg italic text-white/80">{d.tagline}</p>
                      <div className="mt-4 flex items-center gap-2 text-xs text-white/60">
                        <Plane size={12} className="text-lime" />
                        <span>{d.from}</span>
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </section>
    </>
  );
}
